import {EditorSDK} from '@wix/platform-editor-sdk';

import {openDashboardModal} from '@/panels';
import {MultilingualDashboardUrlPath} from '@/types';

export const handleOpenOnboarding = (editorSDK: EditorSDK, token: string) => {
  openDashboardModal(editorSDK, token, MultilingualDashboardUrlPath.ONBOARDING);
};
